// extracted by mini-css-extract-plugin
module.exports = {"tab":"_3kgONCsPQkjPrsJioSYPEM","title":"_1QU0dHkiQhGYGe-_8APwd6","closeBtn":"_2QgeiiNCmG_5nLnjR4ed1K"};